// extracted by mini-css-extract-plugin
export const programIconContainer = "ProgramIconsBlock-module--program-icon-container--InAWQ";
export const singleColumn = "ProgramIconsBlock-module--single-column--2GX-k";
export const programIcon = "ProgramIconsBlock-module--program-icon--2UJ1p";
export const title = "ProgramIconsBlock-module--title--123zo";
export const description = "ProgramIconsBlock-module--description--34UD-";
export const programImg = "ProgramIconsBlock-module--program-img--3M8Pt";
export const linkArrow = "ProgramIconsBlock-module--link-arrow--30gPD";